import { Button, Group, Modal, Text } from "@mantine/core";
import React from "react";

import ModalHeader from "components/ModalHeader";
import { useImpersonateUser } from "api/superAdmin/userSuperAdminId";
import AddOrganizationForm from "./formOrgAdd";

interface User {
  id: string;
  userName: string;
}

type CreateProjectModalProps = {
  opened: boolean;
  onClose: () => void;
};

function ModalOrgForm({ opened, onClose }: CreateProjectModalProps) {
  const { mutate, isLoading } = useImpersonateUser();
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      overlayOpacity={0.5}
      shadow="xs"
      withCloseButton={false}
      transitionDuration={300}
      centered
    >
      <ModalHeader
        title="Create Organization"
        onClose={onClose}
        ariaLabel="Close Organization Modal"
      />
      <AddOrganizationForm onClose={onClose} />
    </Modal>
  );
}

export default ModalOrgForm;
